<template>
<div class="drawerWrap patrolPonitDrawer">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" :label-position="left" label-width="140px">
      <el-form-item label="巡查点编号" prop="pollPointId">
        <el-input v-model="form.pollPointId" minlength="1" maxlength="20" placeholder="请输入巡检点编号"></el-input>
      </el-form-item>
      <el-form-item label="巡查点名称" prop="name">
        <el-input v-model="form.name" minlength="1" maxlength="20" :disabled="handleType=='edit'?true:false" placeholder="请输入巡检点名称"></el-input>
      </el-form-item>
      <el-form-item label="关联部门" prop="relatedDeptId">
        <el-select v-model="form.relatedDeptId" placeholder="关联部门" >
          <el-option
            v-for="item in deptOptions"
            :key="item.id"
            :label="item.deptName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="具体位置" prop="position">
        <el-input v-model="form.position" minlength="1" maxlength="40" placeholder="请输入巡检点名称"></el-input>
      </el-form-item>
      <el-form-item label="详细位置" prop="address">
        <el-input v-model="form.address" minlength="1" maxlength="50" placeholder="请输入巡检点名称"></el-input>
      </el-form-item>
      <el-form-item label="巡检设备类型" :prop="handleType=='edit'?'':'typeId'">
        <treeselect v-model="form.typeId" noResultsText="无匹配项" noOptionsText="暂无数据" :show-count="true" :disable-branch-nodes="true" :flat="false" :multiple="false" :defaultExpandLevel="Infinity" :options="optionsOrg" placeholder="请选择巡检设备类型" clearValueText="清除" clearable :normalizer="normalizer" @deselect="deselectChange" @select="selectChange" @input="inputChange" />
      </el-form-item>
      <div class="isDevice">
        <el-form-item label="已选巡检设备类型">
          <div class="deviceList" v-for="(item,index) in dataList" :key="index">
            <div class="cons">{{item.name}}</div>
            <div class="delBtn" @click="delLevel(item)">
              <el-button size="mini" type="danger" icon="el-icon-delete" circle></el-button>
            </div>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: {
    Treeselect
  },
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    handleType: {
      type: String,
      default: ''
    },
    selectZoneList: {
      type: Array,
      default: []
    },
    deptOptions: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      optionsOrg: [],
      left: "left",
      form: {
        name: "",
        typeIdList: [],
        tenantId: '123456',
        typeId: null,
        pollPointId: '',
        relatedDeptId: '',
        position: '',
        address: '',
      },
      formRules: {
        name: [{ required: true, message: "巡查点名称不能为空", trigger: "blur" }],
        pollPointId: [{ required: true, message: "设备编号不能为空", trigger: "blur" }],
        relatedDeptId: [{ required: true, message: "关联部门不能为空", trigger: "blur" }],
        position: [{ required: true, message: "具体位置不能为空", trigger: "blur" }],
        address: [{ required: true, message: "详细位置不能为空", trigger: "blur" }],
        typeId: [{ required: true, message: "巡检设备类型不能为空", trigger: "blur" }]
      },
      dataList: [],
      change: false,
      typeArry:[],
      delArray:[]
    };
  },
  created() {
    this.init()
    console.log(this.editData);

  },
  mounted() {

  },
  methods: {

    //初始化巡查树
    init() {
      // this.getParentType()
      this.getTreeType()
      if (this.handleType == 'add') {
        this.form = {
          name: "",
          typeIdList: [],
          tenantId: '123456',
          pollPointId: '',
          relatedDeptId: '',
          position: '',
          address: '',
        }
      } else if (this.handleType == 'edit') {
        let typeIds = []
        this.editData.detailInfoDtos.forEach(item => {
          typeIds.push(item.pointTypeId)
        })
        console.log(123, this.editData);
        let { pointName, pollPointId, relatedDeptId, position, address } = this.editData
        this.form = {
          name: pointName,
          typeIdList: typeIds,
          tenantId: '123456',
          pollPointId,
          relatedDeptId,
          position,
          address
        }
        this.getPointType()
      }
    },
    getPointType() {
      let arrrys = this.editData.detailInfoDtos
      arrrys.forEach(item => {
        this.dataList.push({
          typeId: item.pointTypeId,
          name: item.pointTypeName,
          pointId: item.pointId
        })
      })
    },
    //取消
    cancelHandle() {
      this.$emit("cancel", false);
    },
    //确认
    confirmHandle() {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        console.log(this.form);
        delete this.form.typeId
        // return
        this.$emit("confirm", this.form);
        this.$emit("update:loading", true);
      });
    },
    delLevel(data) {
      console.log(data)
      if (this.handleType == 'add') {
        this.form.typeId=null        
        let arry = []
        let ids = []
        this.dataList.forEach(item => {
          if (data.typeId != item.typeId) {
            arry.push(item)
            ids.push(item.typeId)
          }else{
            this.dataList.splice(item,1)
          }
        })
        this.dataList = [...arry]
        this.form.typeIdList = [...ids]
        // console.log(this.dataList);
        // console.log(this.form.typeId);
        if (this.form.typeIdList.length == 0) {
          this.form.typeId = null
        }
      } else if(this.handleType == 'edit'){
        if(this.delArray.length){
          let flag=true
          this.delArray.forEach(item=>{
            if(data.typeId==item.typeId){
              flag=false
            }
          })
          if(!flag){
            this.form.typeId=null        
            let arry = []
            let ids = []
            this.dataList.forEach(item => {
              if (data.typeId != item.typeId) {
                arry.push(item)
                ids.push(item.typeId)
              }else{
                this.dataList.splice(item,1)
              }
            })
            this.dataList = [...arry]
            this.form.typeIdList = [...ids]
            // console.log(this.dataList);
            // console.log(this.form.typeId);
            if (this.form.typeIdList.length == 0) {
              this.form.typeId = null
            }
          }else{
            this.delClick(data)
          }
        }else{
          this.delClick(data)          
        }
      }
    },
    //删除
    delClick(data) {
      let params = {
        tenantId: "123456",
        pointId: data.pointId,
        typeId: data.typeId
      }
      //删除
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          this.request.postParamsData("/front/polling/point/delByTypeId", params).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              let arry = []
              let ids = []
              this.dataList.forEach(item => {
                if (data.typeId != item.typeId) {
                  arry.push(item)
                  ids.push(item.typeId)
                }
              })
              this.dataList = [...arry]
              this.form.typeIdList = [...ids]
              // console.log(this.dataList);
              // console.log(this.form.typeId);
              if (this.form.typeIdList.length == 0) {
                this.form.typeId = null
              }
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //名称校验
    validateNodeLabel(rule, value, callback) {
      if (value === "") {
        callback(new Error("巡检点名称不能为空"));
      } else if (value.length > 20) {
        callback(new Error("巡检点名称长度不能超过20个字符"));
      } else if (value.length < 1) {
        callback(new Error("巡检点名称名长度不能少于1个字符"));
      } else {
        var reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/);
        if (!reg.test(value)) {
          callback(
            new Error("巡检点名称不合法,请输入由_或英文字符或数字组成的用户名！")
          );
        } else {
          callback();
        }
      }
    },
    // 获取树结构巡检设备类型
    getTreeType() {
      this.request.get("/front/polling/type/getTypeTree", {
        "typeName": ""
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.optionsOrg = res.data
          // let typeArry=[]
          // let flag=true
          // this.optionsOrg.forEach(item=>{
          //   if(flag&&item.children!==null&&item.children!=='null'&&item.children.length){
          //     typeArry=item.children
          //     flag=false
          //   }
          // })
          // this.form.typeId=typeArry[0].typeId
        }
      }).catch(error => console.log(error));
    },
    selectChange(data) {
      console.log(data)
      if(this.handleType=='add'){

      }else if(this.handleType=='edit'){
        this.typeArry=this.dataList
        let flag=true
        if(this.typeArry.length){
          this.typeArry.forEach(item=>{
            if(flag&&item.typeId==data.typeId){
              flag=false
              // this.msg.warn("巡检设备类型重复，请重新选择")
            }
          })
          if(flag){
            this.delArray.push(data)
          }
        }else{
          this.delArray.push(data)
        }
        console.log(this.delArray)
      }
      console.log(this.optionsOrg);
      let flag=true
      if(this.typeArry.length){
        this.typeArry.forEach(item=>{
          if(flag&&item.typeId==data.typeId){
            flag=false
            this.msg.warn("巡检设备类型重复，请重新选择")
            this.form.typeId=null
          }
        })
        if(flag){
          this.typeArry.push(data)
        }
      }else{
        this.typeArry.push(data)
      }
      this.dataList=this.typeArry
      console.log(this.dataList)
      let arry=[]
      this.dataList.forEach(item=>{
        arry.push(item.typeId)
      })
      this.form.typeIdList=[...arry]
      console.log(this.form.typeIdList)
    },
    deselectChange(data){
      console.log(data)
    },
    //树形结构
    normalizer(node) {
      //去掉children=null的属性
      if (node.children == null || node.children == 'null') {
        delete node.children;
      }
      if (node.tenantId) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
          // isDisabled:true
        };
      } else {
        return {
          id: node.typeId,
          label: node.name,
          children: node.children,
        };
      }
    },
    inputChange(data) {
      // console.log(data)
      if (data == undefined) {
        this.form.typeId = null
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.drawerWrap {
  font-size: 0;

  .isDevice {
    .deviceList {
      overflow: hidden;

      .cons {
        float: left;
      }

      .delBtn {
        float: right;
      }
    }
  }
}
</style><style lang="scss">
.drawerWrap .drawerBody {
  // padding: 0 20px 0 0;
}

.patrolPonitDrawer {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .patrolCons {
      span {
        font-size: 14px;
        color: #6e6e6e;
        font-weight: 400;
        margin-right: 5px;
      }

      .el-input {
        width: 200px;
        margin-right: 10px;
      }

      b {
        font-size: 14px;
        color: #6e6e6e;
        font-weight: 400;
        padding: 5px;
        cursor: pointer;
      }

      i {
        font-size: 14px;
        color: #6e6e6e;
        font-weight: 400;
        padding: 5px;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;

      .el-checkbox__label {
        width: 240px;
        // text-overflow:ellipsis;
        // overflow:hidden;
        white-space: normal;
      }
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width: 270px;

      .el-textarea__inner {
        height: 100px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
      }
    }

    .custom-tree-node {
      .el-input {
        width: 200px;

        .el-input__inner {
          height: 23px;
          line-height: 23px;
        }
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }

  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }

}
</style>
